export function cleanTheTemplate({ page, fallbackTemplate }) {
    // if this is a product, force product templates
    if (page && page._type === 'product') {
        return 'Product'
    } else if (page && page._type === 'productSingle') {
        return 'ProductSingle'
    }
    // if the page has a content template, use it
    // otherwise use fallback template
    return typeof page.contentTemplateTitle === 'string'
        ? page.contentTemplateTitle
        : fallbackTemplate
}
